export default {
  productType: 'components.views.my-dielines-view.column-product-type',
  size: 'components.views.my-dielines-view.column-size',
  dateCreated: 'components.views.my-dielines-view.column-dateCreated',
  header: 'components.views.my-dielines-view.header'
}
